/**
 * Temporary MN UAN normalize for AI-extracted account numbers.
 * Collapse a trailing check-digit hyphen (e.g. 51-0014854837-7 → 51-00148548377)
 * so values match existing one-hyphen accountNumberRules until the FF/EP regex
 * update accepts XX-XXXXXXXXXX-X. Remove once that DB rule ships.
 */
export function normalizeMnUtilityAccountNumber(value: string): string {
  const trimmed = value.trim();
  const match = /^(\d{2}-\d+)-(\d+)$/.exec(trimmed);
  if (!match) return trimmed;
  return `${match[1]}${match[2]}`;
}
